import { Module } from '@nestjs/common';
import { TypeOrmModule } from '@nestjs/typeorm';
import { AppController } from './app.controller';
import { AppService } from './app.service';
import {appSettings} from '../../../config';
import { WorkstationCategoryModule } from './workstation-category/workstation-category.module';
import { WorkstationsModule } from './workstations/workstations.module';
import { OperationsModule } from './operations/operations.module';
import { VariantOperationsModule } from './variant-operations/variant-operations.module';
import { OperationsTrackModule } from './operations-track/operations-track.module';
import { WorkstationCategories } from './workstation-category/workstation-category.entity'
import { VariantOperation } from './variant-operations/variant-operation.entity';
import { LotCodeOpsEntity } from './operations-track/entities/lot-code.entity';
import { ProductionLog } from './operations-track/entities/production-log.entity';
import { WorkStations } from './workstations/workstations.entity';
import { ProductionInventory } from './operations-track/entities/production-inventory.entity';
import { RawMaterial } from './operations-track/entities/raw-material.entity';
import { Operations } from './operations/operations.entity';
import { GradeInventory } from './operations-track/entities/grade-inventory.entity';
import { GradeInventoryLog } from './operations-track/entities/grade-inventory-log';
import { QaQcOperationsModule } from './qa-qc-operations/qa-qc-operations.module';
import { QaQcOperations } from './qa-qc-operations/qa-qc-operations.entity';
import { RejectionsModule } from './rejections/rejections.module';
import { Rejections } from './rejections/rejections.entity';
import { AssignRejections } from './rejections/assign-rejections.entity';
import { StockTransferLog } from './operations-track/entities/stock-transfer-log';
import { DeheadingSample } from './operations-track/entities/deheading-sample.entity';
import { Labelling } from './operations-track/labelling/entities/labelling.entity';
import { DeheadingQAQC } from './operations-track/entities/de-heading-qa-qc.entity';
import { ProductInspection } from './qa-qc-operations/product-inspection.entity';
import { LabellingSamples } from './operations-track/labelling/entities/labelling-samples.entity';
import { BlanchingCooking } from './operations-track/entities/blanching-cooking.entity';
import { SoakingSampleTest } from './operations-track/entities/soaking-sample-test.entity';
import { GradingMonitoring } from './operations-track/entities/grading-monitoring.entity';
import {Peeling} from './operations-track/peeling/entities/peeling.entity'
import { PeelingSamples } from './operations-track/peeling/entities/peeling-samples.entity';
import { ProductInspectionSamples } from './qa-qc-operations/product-inspection-samples.entity';
import { FgInspectionSamples } from './operations-track/fg-inspection/entities/fg-inspection-samples.entity';
import { FgInspection } from './operations-track/fg-inspection/entities/fg-inspection.entity';
import { MetalDetectionEntity } from './qa-qc-operations/metal-detection/metal-detection.entity';
import { SoakingModule } from './soaking/soaking.module';
import { Soaking } from './soaking/soaking.entity';
import { QcDefect } from './qc-defect-screen/qc-defect-entity';
import { QcDefectModule } from './qc-defect-screen/qc-defect.module';
import { QcdefectitemEntity } from './qc-defect-screen/dto/qc-defect-items-entity';
import { ProductConversionModule } from './product-conversion/product-conversion.module';
import { ProductConversion } from './product-conversion/product-conversion.entity';
import { LotClubbingModule } from './lot-clubbing/lot-clubbing.module';
import { MatserClubbedLots } from './lot-clubbing/lot-clubbing.entity';
import { ChildClubbedLots } from './lot-clubbing/lot-clubbing-items.entity';
import { ScheduleModule } from '@nestjs/schedule';
import { NonSoakedProductsEntity } from './operations-track/entities/non-soaked-products.entity';
import { ProductionWorkersEntity } from './operations-track/entities/production-workers-info.entity';
import { LotInfoEntity } from './operations-track/entities/lot-info.entity';


@Module({
  imports: [
    TypeOrmModule.forRoot({
      type: 'mysql',
      host: appSettings.dbhost,
      port: 3306,
      username: appSettings.dbuser,
      password: appSettings.dbpassword,
      database: appSettings.production_db,
      entities: [
        WorkstationCategories,
        WorkStations,
        LotCodeOpsEntity,
        ProductionLog,
        RawMaterial,
        ProductionInventory,
        VariantOperation,
        Operations,
        GradeInventory,
        QaQcOperations,
        GradeInventoryLog,
        Rejections,
        AssignRejections,
        StockTransferLog,
        DeheadingSample,
        Labelling,
        ProductInspection,
        LabellingSamples,
        DeheadingQAQC,
        BlanchingCooking,
        SoakingSampleTest,
        GradingMonitoring,
        Peeling,
        PeelingSamples,
        ProductInspectionSamples,
        FgInspection,
        FgInspectionSamples,
        MetalDetectionEntity,
        Soaking,
        QcDefect,
        QcdefectitemEntity,
        ProductConversion,
        MatserClubbedLots,
        ChildClubbedLots,
        NonSoakedProductsEntity,
        ProductionWorkersEntity,
        LotInfoEntity
      ],
      // synchronize: mastersConfigs.sync,
      synchronize: false,
      logging: true,
      // logger: new QueryLogger(new PinoLogger({ pinoHttp: { level: mastersConfigs.loggingMode } })),/
    }
    ),
    ScheduleModule.forRoot(),
   WorkstationCategoryModule, WorkstationsModule, OperationsModule, VariantOperationsModule, OperationsTrackModule, QaQcOperationsModule, RejectionsModule, SoakingModule, QcDefectModule,ProductConversionModule,LotClubbingModule
  ],
  controllers: [AppController],
  providers: [AppService],
})
export class AppModule {}
